/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6c53eedc-a1ca-4b71-8595-8a6bb1200f4e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rHSkcnAQG",
    "aws_user_pools_web_client_id": "2rukkri2i8bfsgggu8prhs2il0",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "camly123-dev": {
                        "style": "VectorEsriNavigation"
                    }
                },
                "default": "camly123-dev"
            }
        }
    }
};


export default awsmobile;
